import { ImportFileDialog } from "@/components/CSV/ImportFileDialog";
import type { RowData } from "./Index";
import { columnsKey } from "./Index";
import { createEmptyRow } from "./helper";

interface CSVImportFileDialogProps {
	open: boolean;
	onClose: () => void;
	onImport: (rows: RowData[]) => void;
}

function parseProxyRow(raw: Record<string, any>): RowData {
	const ip = raw.ipAddress != null ? String(raw.ipAddress).trim() : null;
	const username = raw.username != null ? String(raw.username).trim() : null;
	const password = raw.password != null ? String(raw.password).trim() : null;
	let port: number | null = null;
	if (
		raw.port !== undefined &&
		raw.port !== null &&
		String(raw.port).trim() !== ""
	) {
		const n = Number(raw.port);
		port = Number.isFinite(n) ? n : null;
	}
	return {
		ipAddress: { value: ip, disabled: false, isValid: true },
		username: { value: username, disabled: false, isValid: true },
		password: { value: password, disabled: false, isValid: true },
		port: { value: port, disabled: false, isValid: true },
		isRowValid: true,
	};
}

const CSVImportFileDialog: React.FC<CSVImportFileDialogProps> = ({
	open,
	onClose,
	onImport,
}) => {
	return (
		<ImportFileDialog<RowData>
			createEmptyRow={createEmptyRow}
			open={open}
			onClose={onClose}
			requiredColumns={columnsKey}
			parseRow={parseProxyRow}
			onImport={onImport}
		/>
	);
};

export default CSVImportFileDialog;
